var _polygon, _polygon2, _polygon3, _polygon4, _circle, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _circle2, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _circle3, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _circle4, _polygon28, _polygon29, _polygon30, _polygon31, _circle5, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanineDental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dental",
    viewBox: "0 0 1062 1440",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: 101,
    points: "529, 70, 538, 22, 525, 12, 506, 12, 501, 22, 488, 27, 493, 40, 515, 74",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: 102,
    points: "480, 82, 488, 63, 483, 35, 463, 27, 437, 32, 435, 50, 429, 62",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: 103,
    points: "384, 125, 411, 129, 430, 83, 404, 63, 374, 72, 366, 86",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: 104,
    points: "301, 138, 392, 150, 413, 179, 412, 218, 397, 233, 365, 237, 342, 209",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: 105,
    cx: 372,
    cy: 289,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: 106,
    points: "329, 392, 333, 372, 332, 352, 354, 333, 367, 336, 371, 350, 342, 394",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: 107,
    points: "274, 481, 287, 442, 316, 413, 341, 416, 337, 439, 325, 459, 296, 484",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: 108,
    points: "341, 525, 325, 537, 304, 542, 292, 559, 289, 578, 279, 600, 246, 613, 225, 596, 217, 558, 233, 514, 258, 499, 302, 506, 33",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: 109,
    points: "245, 617, 290, 602, 349, 620, 380, 633, 384, 649, 365, 656, 322, 661, 305, 673, 278, 683, 263, 671, 248, 638",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: 110,
    points: "278, 688, 309, 675, 341, 680, 361, 700, 292, 706, 276, 698",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: 201,
    points: "560, 66, 586, 69, 609, 28, 600, 19, 585, 8, 564, 15, 551, 28",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: 202,
    points: "611, 82, 621, 91, 635, 89, 650, 60, 669, 50, 666, 34, 650, 23, 623, 24, 612, 30",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: 203,
    points: "658, 108, 661, 83, 684, 63, 710, 58, 731, 65, 744, 79, 718, 95, 709, 111, 702, 128",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: 204,
    points: "735, 236, 745, 205, 799, 144, 794, 133, 779, 129, 710, 155, 690, 167, 681, 195, 682, 215, 699, 236, 717, 242",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: 205,
    cx: 705,
    cy: 287,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: 206,
    points: "696, 338, 728, 334, 741, 357, 746, 391, 734, 405, 710, 405, 700, 395",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: 207,
    points: "702, 439, 719, 420, 741, 427, 764, 443, 776, 465, 779, 492, 769, 505, 736, 498, 712, 482",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: 208,
    points: "717, 520, 708, 531, 763, 569, 758, 585, 791, 610, 828, 614, 843, 595, 849, 559, 819, 511, 795, 504",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    id: 209,
    points: "696, 656, 707, 626, 757, 611, 827, 616, 835, 644, 822, 651, 815, 679",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    id: 210,
    points: "797, 701, 798, 711, 773, 720, 765, 711, 735, 706, 736, 696, 760, 678, 785, 676, 812, 684",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    id: 301,
    points: "529, 1414, 532, 1385, 526, 1359, 542, 1359, 548, 1383, 561, 1401, 557, 1417",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    id: 302,
    points: "560, 1385, 556, 1355, 569, 1355, 581, 1380, 604, 1400, 603, 1409, 572, 1415",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    id: 303,
    points: "589, 1357, 606, 1351, 625, 1374, 659, 1380, 664, 1407, 639, 1412, 611, 1398",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    id: 304,
    points: "654, 1280, 670, 1297, 685, 1317, 724, 1327, 746, 1327, 732, 1356, 710, 1368, 655, 1365, 615, 1349, 597, 1323, 602, 1297, 622, 1280",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: 305,
    cx: 641,
    cy: 1240,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    id: 306,
    points: "634, 1204, 644, 1186, 638, 1165, 666, 1163, 676, 1202, 657, 1219",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    id: 307,
    points: "655, 1078, 702, 1080, 683, 1139, 649, 1124",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    id: 308,
    points: "693, 1011, 712, 995, 730, 997, 744, 1024, 714, 1057, 689, 1046",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    id: 309,
    points: "702, 861, 722, 849, 762, 849, 784, 923, 779, 950, 728, 993, 700, 989, 689, 941",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    id: 310,
    points: "710, 830, 718, 806, 717, 788, 746, 784, 762, 795, 758, 828, 742, 838",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: 311,
    cx: 745,
    cy: 760,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    id: 401,
    points: "489, 1413, 516, 1416, 520, 1395, 512, 1383, 517, 1364, 502, 1364",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    id: 402,
    points: "443, 1397, 466, 1377, 472, 1355, 484, 1355, 494, 1378, 485, 1410, 462, 1412",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    id: 403,
    points: "386, 1370, 458, 1353, 422, 1399, 390, 1386",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    id: 404,
    points: "265, 1333, 296, 1333, 351, 1289, 379, 1273, 402, 1271, 418, 1293, 419, 1315, 405, 1340, 355, 1368, 305, 1367, 277, 1355",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: 405,
    cx: 383,
    cy: 1232,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    id: 406,
    points: "360, 1150, 388, 1152, 392, 1193, 371, 1202, 351, 1186",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    id: 407,
    points: "338, 1065, 357, 1054, 376, 1056, 385, 1113, 353, 1130, 331, 1090",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    id: 408,
    points: "293, 1026, 297, 979, 327, 976, 342, 988, 341, 1044, 312, 1046",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    id: 409,
    points: "263, 942, 278, 873, 265, 849, 299, 832, 325, 835, 342, 854, 345, 908, 349, 943, 339, 968, 302, 975, 268, 959",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    id: 410,
    points: "290, 775, 325, 772, 333, 818, 321, 831, 298, 829, 284, 815, 284, 794, 279, 782",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: 411,
    cx: 312,
    cy: 750,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanineDental);
export default __webpack_public_path__ + "static/media/CanineDental.17db03332e3df9233abc53564f2a53ef.svg";
export { ForwardRef as ReactComponent };